<script setup lang="ts">
import { computed } from '#imports';

interface Props {
	modelValue: string;
	tabs: Array<{
		title: string;
		content: any;
	}>;
}

const props = defineProps<Props>();
const emit = defineEmits<{
	(e: 'update:modelValue', title: string): void;
}>();

const activeTab = computed({
	get: () => props.modelValue,
	set: (val) => emit('update:modelValue', val),
});

const activeClass = (title: string) => ({
	'tabs__panel-button--active': activeTab.value === title,
});

const handleClick = (title: string) => {
	activeTab.value = title;
};
</script>

<template>
	<div class="tabs">
		<ul class="tabs__panel">
			<li
				v-for="tab in tabs"
				:key="tab.title"
				class="tabs__panel-item"
			>
				<button
					class="tabs__panel-button button"
					:class="activeClass(tab.title)"
					@click="handleClick(tab.title)"
				>
					{{ tab.title }}
				</button>
			</li>
		</ul>

		<div class="tabs__content">
			<component :is="tabs?.find((tab) => tab.title === activeTab)?.content" />
		</div>
	</div>
</template>

<style lang="scss" scoped>
.tabs {

	&__panel {
		position: relative;

		display: flex;
		overflow-x: auto;
		align-items: center;
		gap: rem(20px);

		margin-bottom: rem($gap-medium);

		border-bottom: rem(1px) solid #CFCFD3;
	}

	&__panel-button {
		@include text-mini;

		position: relative;

		padding: rem($gap-micro);

		text-transform: uppercase;

		color: $black;

		&--active {
			font-weight: 500;

			&::before {
				position: absolute;
				z-index: 2;
				bottom: rem(0px);
				left: 0;

				width: 100%;
				height: rem(1px);

				content: "";

				background-color: $black;
			}
		}
	}
}

</style>
